module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_7_1679200d702b7d360bfc5ec5d9f75b8e.png";